/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Customize_AnswerInputs */

const en_landing_faq_customize_answer = /** @type {(inputs: Landing_Faq_Customize_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The src/blocks/ directory ships with demo sections — they're designed to be rewritten per project. The durable primitives live in src/components/, so your rebrand touches blocks and translations, not the chassis.`)
};

const zh_landing_faq_customize_answer = /** @type {(inputs: Landing_Faq_Customize_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`src/blocks/ 下的 section 都是示例内容，本来就是要每个项目自己重写的。src/components/ 里才是长期沉淀的基础组件——换品牌只动 blocks 和翻译，底层架构不变。`)
};

/**
* | output |
* | --- |
* | "The src/blocks/ directory ships with demo sections — they're designed to be rewritten per project. The durable primitives live in src/components/, so your re..." |
*
* @param {Landing_Faq_Customize_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_customize_answer = /** @type {((inputs?: Landing_Faq_Customize_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Customize_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_customize_answer(inputs)
	return zh_landing_faq_customize_answer(inputs)
});
export { landing_faq_customize_answer as "landing.faq.customize.answer" }